export default class GrilleTarifs {
  constructor(view) {
    this.view = view;

    // Bindings
    this.onClickAnchor = this.onClickAnchor.bind(this);
    this.onClickSubAnchor = this.onClickSubAnchor.bind(this);
    this.onToggleSupport = this.onToggleSupport.bind(this);
    this.onPopupToggle = this.onPopupToggle.bind(this);
    this.onPopupClose = this.onPopupClose.bind(this);
    this.onToggleMobileDropdown = this.onToggleMobileDropdown.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.onWindowClick = this.onWindowClick.bind(this);

    // DOM
    this.container = this.view.querySelector(".grille-tarifs__container");
    this.anchors = Array.from(this.view.querySelectorAll(".grille-tarifs__anchor, .grille-tarifs__mobile-anchors__anchor"));
    this.subAnchors = Array.from(this.view.querySelectorAll(".grille-tarifs__sub-anchors__dropdown > a"));

    this.mobileDropdown = this.view.querySelector(".grille-tarifs__mobile-anchors");
    this.mobileDropdownToggle = this.mobileDropdown.querySelector(".grille-tarifs__mobile-anchors__toggle");
    this.mobileDropdownToggleLabel = this.mobileDropdown.querySelector(".grille-tarifs__mobile-anchors__header__label");

    this.contents = this.view.querySelectorAll(".grille-tarifs__content");
    this.dropdownButtons = this.view.querySelectorAll(".grille-tarifs__dropdown-toggle, .grille-tarifs__sub-anchors__toggle");
    this.infoPopupsOpen = this.view.querySelectorAll(".info-popup__btn");
    this.infoPopupsClose = this.view.querySelectorAll(".info-popup__close");

    // Event listeners
    for (var i = 0; i < this.anchors.length; i++) {
      this.anchors[i].addEventListener("click", this.onClickAnchor);
    }

    for (var i = 0; i < this.dropdownButtons.length; i++) {
      this.dropdownButtons[i].addEventListener("click", this.onToggleSupport);
    }

    this.mobileDropdownToggle.addEventListener("click", this.onToggleMobileDropdown);

    for (var i = 0; i < this.infoPopupsOpen.length; i++) {
      this.infoPopupsOpen[i].addEventListener("click", this.onPopupToggle);
      this.infoPopupsClose[i].addEventListener("click", this.onPopupClose);
    }

    for (var i = 0; i < this.subAnchors.length; i++) {
      this.subAnchors[i].addEventListener("click", this.onClickSubAnchor);
    }

    // resize (used for mobile anchor stickyness)
    window.addEventListener("resize", this.onWindowResize);
    window.addEventListener("click", this.onWindowClick);
    this.onWindowResize();

    // Init
    this.init();
  }

  init() {
    // get current hash from URL
    let hash = window.location.hash;

    // if there's a hash in the URL:
    if (hash) {
      let testAnchor = this.anchors.find((x) => x.getAttribute("href") === hash);
      let targetAnchors, content, parentHash;

      // are we dealing with sub-anchors?
      if (!testAnchor) {
        testAnchor = this.subAnchors.find((x) => x.getAttribute("href") == hash);
        parentHash = "#" + testAnchor.closest(".grille-tarifs__content").getAttribute("id");

        // redefine elements to target parent hash instead
        targetAnchors = this.anchors.filter((x) => x.getAttribute("href") === parentHash);
        content = this.view.querySelector(parentHash);
      } else {
        targetAnchors = this.anchors.filter((x) => x.getAttribute("href") === hash);
        content = this.view.querySelector(hash);
      }

      if (targetAnchors.length && content) {
        // remove selected class on those that already had it
        // in this case we can just assume it's the first anchor/section pairing
        const selectedAnchors = this.anchors.filter((x) => x.classList.contains("selected"));
        selectedAnchors.forEach((a) => a.classList.remove("selected"));
        this.contents[0].classList.remove("selected");

        // add selected class to targeted elements
        targetAnchors.forEach((anchor) => anchor.classList.add("selected"));
        content.classList.add("selected");

        // set text of mobile toggle
        this.mobileDropdownToggleLabel.innerText = targetAnchors[0].innerText;

        // scroll to targeted section
        if (parentHash) {
          this.scrollToContent(this.view.querySelector(hash), window.innerWidth <= 640 ? -110 : 0);
        } else {
          this.scrollToContent(content);
        }
      }
    }
  }

  onClickAnchor(e) {
    // prevent default behavior (make sure this doesn't affect accessibility)
    e.preventDefault();

    // special mobile case
    e.currentTarget.blur();

    // els
    const nextHash = e.currentTarget.getAttribute("href");
    const prevAnchors = this.anchors.filter((x) => x.classList.contains("selected"));
    const nextAnchors = this.anchors.filter((x) => x.getAttribute("href") === nextHash);

    const prevContent = this.view.querySelector(".grille-tarifs__content.selected");
    const nextContent = this.view.querySelector(nextHash);

    // remove selected class
    prevAnchors.forEach((anchor) => anchor.classList.remove("selected"));
    prevContent.classList.remove("selected");

    // add selected class
    nextAnchors.forEach((anchor) => anchor.classList.add("selected"));
    nextContent.classList.add("selected");

    // push URL
    window.location.hash = nextHash;

    // tracking
    const click_text = e.currentTarget.innerText;
    const click_url = window.location.href;
    const internal = true;
    const cta_type = "section grille tarifaire";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "categorie_titre",
      click_text,
      click_url,
      cta_type,
      internal,
    });

    // set text of mobile dropdown label
    this.mobileDropdownToggleLabel.innerText = nextAnchors[0].innerText;

    // auto-close mobile dropdown if it's open
    this.mobileDropdown.classList.remove("open");

    // scroll back to top
    this.scrollToContent(nextContent);
  }

  onClickSubAnchor(e) {
    // prevent default behavior
    e.preventDefault();

    // get values
    const hash = e.currentTarget.getAttribute("href");
    const content = this.view.querySelector(hash);

    // set URL
    window.location.hash = hash;

    // close dropdown
    e.currentTarget.parentElement.previousElementSibling.classList.remove("open");

    // scroll to content
    this.scrollToContent(content, window.innerWidth <= 640 ? -110 : 0);
  }

  scrollToContent(content, offset = -120) {
    // always scrolling to top of container
    const top = content.getBoundingClientRect().top - document.body.getBoundingClientRect().top;

    // timeout
    // setTimeout(() => {
    //   window.scrollTo(0, top + offset, { behavior: "smooth" });
    // }, 10);
  }

  onToggleSupport(e) {
    e.preventDefault();

    // els
    const toggle = e.currentTarget;
    const content = toggle.nextElementSibling;

    // set height
    const height = content.scrollHeight;
    content.style.setProperty("--height", height + "px");

    // toggle class
    toggle.classList.toggle("open");
  }

  onToggleMobileDropdown(e) {
    const anchorContainer = this.mobileDropdown.querySelector(".grille-tarifs__mobile-anchors__anchors");
    anchorContainer.style.setProperty("--height", anchorContainer.scrollHeight + "px");
    this.mobileDropdown.classList.toggle("open");
  }

  onPopupToggle(e) {
    const panel = e.currentTarget.nextElementSibling;
    const table = panel.closest("table");
    const previousUpfront = this.view.querySelector("table.upfront");

    // close any previously open popup
    if (!panel.classList.contains("open")) {
      const previouslyOpen = this.view.querySelector(".info-popup__popup.open");
      if (previouslyOpen && previouslyOpen !== panel) previouslyOpen.classList.remove("open");
    }

    // toggle open state
    panel.classList.toggle("open");
    if (panel.classList.contains("open")) {
      // set position
      const bounds = e.currentTarget.getBoundingClientRect();
      const panelBounds = panel.getBoundingClientRect();
      const maxTop = window.innerHeight - panelBounds.height - bounds.height - 24;
      const maxLeft = window.innerWidth - panelBounds.width - 64;

      // console.log("popup top", bounds.top, maxTop);
      panel.style.setProperty("--popup-top", Math.min(bounds.top, maxTop) + "px");
      panel.style.setProperty("--popup-left", Math.min(bounds.left, maxLeft) + "px");

      // bring table up front
      if (previousUpfront) previousUpfront.classList.remove("upfront");
      table.classList.add("upfront");
    }
  }

  onPopupClose(e) {
    const panel = e.currentTarget.parentElement;
    const table = panel.closest("table");
    panel.classList.remove("open");
    const previousUpfront = this.view.querySelector("table.upfront");

    if (previousUpfront) previousUpfront.classList.remove("upfront");
    table.classList.add("upfront");
  }

  onWindowResize() {
    const height = this.mobileDropdown.getBoundingClientRect().height;
    this.view.style.setProperty("--mobile-sticky-height", height - 1 + "px");
  }

  onWindowClick(e) {
    if (!e.target.closest(".info-popup")) {
      const popups = this.view.querySelectorAll(".info-popup__popup.open");
      for (let i = 0; i < popups.length; i++) {
        popups[i].classList.remove("open");
      }
    }
  }
}
